import { IconDefinition } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Typography } from "@mui/material"
import React from "react"
import { FlexBox } from "ui/components/FlexBox"

interface IListMessageProps {
  message: string
  icon: IconDefinition
  id?: string
  small?: boolean
  sx?: any
}

export const ListMessage = React.memo(({ message, icon, id, small, sx }: IListMessageProps) => (
  <FlexBox
    id={id}
    gap
    jc="start"
    fullWidth
    sx={{
      "m": "2rem",
      "& .icon": {
        color: theme => theme.palette.text.secondary,
        fontSize: small ? "2rem" : "3rem"
      },
      ...sx
    }}>
    <FontAwesomeIcon id={id ? `${id}-icon` : undefined} icon={icon} className="icon" />
    <Typography id={id ? `${id}-text` : undefined} color="textSecondary">
      {message}
    </Typography>
  </FlexBox>
))
